import styled, { css } from 'styled-components';
import { AScrimGradientDirection } from './AScrimGradient.types';

export const Wrapper = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const SafeZone = styled.div`
  position: absolute;
  inset: 0;
  background-color: var(--t-color-scrim-100);
`;

const getGradientRampStyles = (direction: AScrimGradientDirection) => {
  switch (direction) {
    case AScrimGradientDirection.BottomToTop:
      return css`
        inset-block-start: -50%;
        inset-block-end: 100%;
        inset-inline-start: 0;
        inset-inline-end: 0;
        background: linear-gradient(to top, var(--t-color-scrim-100), var(--t-color-scrim-0));
      `;
    case AScrimGradientDirection.TopToBottom:
      return css`
        inset-block-start: 100%;
        inset-block-end: -50%;
        inset-inline-start: 0;
        inset-inline-end: 0;
        background: linear-gradient(to bottom, var(--t-color-scrim-100), var(--t-color-scrim-0));
      `;
    case AScrimGradientDirection.LeftToRight:
      return css`
        inset-block-start: 0;
        inset-block-end: 0;
        inset-inline-start: 100%;
        inset-inline-end: -50%;
        background: linear-gradient(to right, var(--t-color-scrim-100), var(--t-color-scrim-0));
      `;
    case AScrimGradientDirection.RightToLeft:
      return css`
        inset-block-start: 0;
        inset-block-end: 0;
        inset-inline-start: -50%;
        inset-inline-end: 100%;
        background: linear-gradient(to left, var(--t-color-scrim-100), var(--t-color-scrim-0));
      `;
    default: {
      const _exhaustive: never = direction;
      return css``;
    }
  }
};

export const GradientRamp = styled.div<{ $direction: AScrimGradientDirection }>`
  position: absolute;

  ${({ $direction }) => getGradientRampStyles($direction)}

  @media (prefers-reduced-transparency: reduce) {
    display: none;
  }
`;
